import { Box, Button, Container, Grid, Input, MenuItem, Radio, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Stack } from "@mui/material"
import Bottom from "../../Bottom";
import { useEffect } from "react";
import api from "../../../utils/api";

import { useLocation, useNavigate } from "react-router-dom";

import $ from 'jquery';
import tabbg from "../../../assets/images/tab_02.png"
import useHraStore from "../../../store/hraStores";


import ButtonBase from '@mui/material/ButtonBase';
import { responsiveFontSizes, styled } from '@mui/material/styles';
import reimg1 from "../../../assets/images/reimg1.png";
import reimg2 from "../../../assets/images/reimg2.png";
import reimg3 from "../../../assets/images/reimg3.png";

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Alert from '@mui/material/Alert';
import Paper from '@mui/material/Paper';
import { notifyApiError } from "../../../utils/apiError";


const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

// 새로고침 이미지 변경
const ImgArr = [reimg1, reimg3,];
const randomIndex = Math.floor(Math.random() * ImgArr.length);
const reTopImg = ImgArr[randomIndex];

const HraAnswer = () => {
  const img = {
    display: 'flex', p: 0, backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
  }
  const storeData: any = useHraStore();
  const navigate = useNavigate();
  const location = useLocation();

  const sex = localStorage.getItem('sex')

  useEffect(() => {
    getQuestionsList();

    // genRowspan('number');

    return () => {
      storeData.Answerclear();
    }
  }, [])

  useEffect(() => {

    genRowspan('number');

  }, [storeData.questionsList])

  function getQuestionsList() {
    // state 가 없으면(새로고침·직접 URL 접근) 대상 가족/연도를 알 수 없다.
    if (!location.state) return;

    let userId: any = localStorage.getItem('userID');
    //family_id=${encodeURIComponent(familyId)}&year=${year}

    api.get(`customer/api/v2/surveys/hra?family_id=${encodeURIComponent(location.state.family_id)}&year=${location.state.year}`, { headers: { 'userId': userId } })
      .then(res => {
        console.log(res);

        res.data.data.questions.sort((a: any, b: any) => a.sub_number - b.sub_number).sort((a: any, b: any) => a.number - b.number);
        storeData.setAssignedUid(res.data.data.assigned_uid);

        const tempList = [];
        let tempTitle = '';
        let tempTypeList = [''];
        let tempUidList = [''];
        let tempOptionList = [''];
        for (let i = 0; i < res.data.data.questions.length; i++) {
          const question = res.data.data.questions[i];
          const tempObj: any = {};
          const isSplitable = question.title.indexOf('(*)') > -1;
          const title = isSplitable ? question.title.split('(*)') : '';

          tempObj.type = question.type;
          tempObj.number = question.number;
          tempObj.limit = question.limit;
          tempObj.sub_number = question.sub_number;
          tempObj.sub_number_id = getSubNumberObj(question.number, question.sub_number);
          tempObj.title = question.title;
          tempObj.question_uid = question.uid;
          tempObj.option = question.option;

          tempObj.isSplitable = isSplitable;
          tempObj.splitableTitle = title;


          if (question.title.indexOf('(*)') > -1) {
            tempTitle += question.title;
            tempTypeList.push(question.type);
            tempUidList.push(question.uid);
            tempOptionList.push(question.option);
          }

          if (!!question.option) {
            const entries = Object.entries(question.option);
            const keys = entries.map(v => v[0]);
            const values = entries.map(v => v[1]);
            tempObj.entries = entries;
            tempObj.optionKeys = keys;
            tempObj.optionValues = values;
          }

          tempObj.answers = [];

          // if (!!question.option) {
          //   const entries = Object.entries(question.option);
          //   const keys = entries.map(v => v[0]);
          //   const values = entries.map(v => v[1]);
          //   let thisTitle = isSplitable ? title[0] : title;
          //   tempObj.answers += thisTitle;

          //   if (question.type !== "select") { // radio, checkbox
          //     for (let i = 0; i < entries.length; i++) {
          //       tempObj.answers += question.number !== 4 || question.sub_number === null ? '<td class="w-12 ws-n">' : "";
          //       if (keys[i] !== "hidden") tempObj.answers += `<span style="margin-right: .5rem;"><input class="stress" name="${question.uid}" type="${question.type}" value="${values[i]}">${question.number === 4 && question.sub_number !== null ? `<label>${keys[i]}</label>` : ''}</span>`;
          //       else tempObj.answers += `<input class="stress" name="${question.uid}" type="${question.type}" value="${values[i]}" ${keys[i]}>`;
          //       tempObj.answers += question.number !== 4 && question.sub_number === null ? "</td>" : "";
          //     }
          //     if (isSplitable) {
          //       if (title[0].length > 1) tempObj.answers += `<span style="padding-right: .5rem;">${title[0]}</span>`
          //       if (title[1].length > 1) tempObj.answers += `<span style="padding-right: .5rem;">${title[1]}</span>`
          //       if (title[2].length > 1) tempObj.answers += `<div style="padding-right: .5rem;">${title[2]}</div>`
          //       tempObj.answers += question.number === 4 && question.sub_number === 3 ? "</td>" : "";
          //     }
          //   } else { // select
          //     tempObj.answers += thisTitle;
          //     tempObj.answers += `<select name="${question.uid}">`;
          //     for (let i = 0; i < entries.length; i++) tempObj.answers += `<option class="stress" name="${values[i]}" value="${values[i]}">${keys[i]}</option>`;
          //     tempObj.answers += `</select>`;
          //     if (isSplitable) {
          //       if (title[0]) if (title[0].length > 1) tempObj.answers += `<span style="padding-right: .5rem;">${title[0]}</span>`
          //       if (!!title[1]) if (title[1].length > 1) tempObj.answers += `<span style="padding-right: .5rem;">${title[1]}</span>`
          //       if (!!title[2]) if (title[2].length > 1) tempObj.answers += `<div style="padding-right: .5rem;">${title[2]}</div>`
          //       tempObj.answers += question.number === 4 && question.sub_number === 3 ? "</td>" : "";
          //     }
          //   }
          // } else { // text, number
          //   tempObj.answers += `<span style="padding: 0 .5rem;">${title[0]}</span><input style="width: 5rem;" class="stress" name="${question.uid}" type="${question.type}" min="1" max="64">
          //   ${!!title[1] ? `<span style="padding: 0 .5rem;">${title[1]}</span>` : ''}
          //   ${!!title[2] ? `<div style="padding-top:1rem; font-size: 90%;">${title[2]}</div>` : ''}`;
          // }

          tempList.push(tempObj);
        }
        console.log(tempList);

        let titleObjList = [];
        for (let i = 0; i < tempTitle.split('(*)').length; i++) {
          let titleObj: any = {};
          titleObj.title = tempTitle.split('(*)')[i];
          titleObj.type = tempTypeList[i] == undefined ? '' : tempTypeList[i];
          titleObj.uid = tempUidList[i];
          titleObj.option = tempOptionList[i];
          titleObjList.push(titleObj);
        }
        // const tableDiv = '#table #tb-body tbody';

        // drawTableTerms(tableDiv, tempList, 0, tempList.filter(d => d.number < 5).length);
        // drawTableTerms(tableDiv, tempList, tempList.filter(d => d.number < 5).length, tempList.length);
        storeData.setSplitableTitleList(titleObjList);
        storeData.setQuestionsList(tempList);
      })
      .catch(err => {
        console.log(err);
      });
  }

  // 카테고리 rowspan 함수
  const genRowspan = (className: string) => {
    const elements = Array.from(
      document.querySelectorAll(`.${className}`)
    ) as HTMLTableCellElement[];
    let lastCategory = "";
    let rowspan = 1;
    let firstElement: HTMLTableCellElement | null = null;

    elements.forEach((element) => {
      const text = element.textContent;

      if (text === lastCategory) {
        rowspan++;
        element.style.display = "none";
        if (firstElement) {
          firstElement.setAttribute("rowspan", rowspan.toString());
        }
      } else {
        lastCategory = text || "";
        rowspan = 1;
        firstElement = element;
        element.removeAttribute("rowspan");
        element.style.display = "";
      }
    });
  };

  function getSubNumberObj(number: any, subNumber: any) {
    if (!!subNumber) {
      if (number === 4) return "direct-family";
      else if (number === 5) return "다음과 같은 질병으로 진단을 받았거나 현재 약물치료 중이십니까?";
    } else return undefined;
  }

  // function drawTableTerms(tableDiv: any, data: any, start: any, end: any) {
  //   const table = document.createElement("table");
  //   $(tableDiv).append(table);
  //   const dLen = data.length;
  //   let row = "";
  //   let nowNum = 0;
  //   let isOpen = false;
  //   for (let i = start; i < (end < dLen ? end : dLen); i++) {
  //     const now = data[i];
  //     const viewNumber = sessionStorage.getItem("sex") !== "F" ? now.number - 1 : now.number;
  //     const idNumber = (`${viewNumber}`).concat(now.sub_number !== null ? `-${now.sub_number}` : '');
  //     nowNum = now.number;
  //     const nextNum = i + 1 < dLen ? data[i + 1].number : nowNum + 1;
  //     if (now.title.indexOf("(*") < 0) {
  //       if (nowNum === 5 && now.sub_number === 1) {
  //         row += `<tr id="stress-${nowNum}" class="sub-title-row" >`
  //         row += `<td class="w-6">${viewNumber}</td>`;
  //         row += `<td class="left-alg" colspan="3" style="font-weight: bold;">${now.sub_number_id}</td>`
  //         row += `</tr>`;
  //       }
  //       row += `<tr id="stress-${idNumber}" ${sessionStorage.getItem("sex") !== "F" && now.number === 1 ? 'style="display:none;"' : ""}>
  //               <td class="w-6">${viewNumber}</td>
  //               <td class="left-alg">${now.title}</td>
  //               ${now.answers}
  //           </tr>`;
  //     } else {
  //       if (nowNum === nextNum && isOpen === false && now.sub_number !== null) {
  //         row += `<tr style="display:none;" id="direct-family">`
  //         row += `<td class="w-6">${viewNumber}</td>`;
  //         row += `<td colspan="3" class="left-alg">`
  //         isOpen = true;
  //       }
  //       row += now.answers;
  //       if (nowNum !== nextNum && isOpen !== false) row += `</td></tr>`;
  //     }
  //   }
  //   $(table).append(row);
  // }

  // function setTable(data: any) {
  //   const tableDiv = '#table #tb-body tbody';

  //   drawTableTerms(tableDiv, data, 0, data.filter((d: any) => d.number < 5).length);
  //   drawTableTerms(tableDiv, data, data.filter((d: any) => d.number < 5).length, data.length);

  //   return data;
  // }

  // 설문 제출하기
  function handleSubmitSurvey() {
    if (window.confirm("제출 후에는 수정할 수 없습니다.\n정말 제출하시겠습니까?")) {
      let valueStatus = true;
      const answer = [];
      const dLen = storeData.questionsList.length;

      for (let i = 0; i < dLen; i++) {
        const d = storeData.questionsList[i];
        const input = $(`input[name="${d.question_uid}"]${d.type !== 'text' || d.type !== 'number' ? ':checked' : ''}`);
        let value: any;

        if (d.type === 'checkbox') {
          valueStatus &&= d.limit === $(input).filter((v: any) => !!$(v).val() && $(v).val().length !== 0).length;
          value = $(input).map((v: any) => $(v).val());
        } else if (d.type === 'select') { // 직계가족 선택
          value = storeData.selected;
        } else if (d.type === 'number') { // 나이
          value = storeData.age;
        } else if (d.number === 5 && d.sub_number === null) { // pass
          // console.log(d.number);
          continue;
        } else { // radio
          if (sex !== 'F' && i == 0) {
            value = '0';
          } else {
            value = $(input).val();
            valueStatus &&= (!!value && value.length !== 0);
          }
        }

        if (!!!value || value.length < d.limit) {
          const viewNumber = sex !== "F" ? d.number - 1 : d.number;
          const idNumber = (`${viewNumber}`).concat(d.sub_number !== null ? `-${d.sub_number}` : '');
          if (d.sub_number_id !== undefined && d.sub_number_id.replaceAll(/[a-zA-Z\-_]/ig, "").length === 0) {
            $(`#${d.sub_number_id}`).children('td').not('.category').addClass('focusing');
            $(`#${d.sub_number_id}`).focus();
          } else {
            if (d.number === 5) {
              $(`#stress-${d.number}`).children('td').not('.category').addClass('focusing');
              $(`#stress-${d.number}`).focus();
            }
            $(`#stress-${idNumber}`).children('td').not('.category').addClass('focusing');
            $(`#stress-${idNumber}`).focus();
          }
        }

        if (d.type === "checkbox") answer[i] = { question: { uid: d.question_uid }, answer: JSON.stringify($(input).map((v: any) => $(v).val())) };
        else if (d.type === 'select') answer[i] = { question: { uid: d.question_uid }, answer: storeData.selected };
        else if (d.type === 'number') answer[i] = { question: { uid: d.question_uid }, answer: storeData.age };
        else if (d.number === 5 && d.sub_number === null) continue
        else if (sex !== 'F' && i == 0) answer[i] = { question: { uid: d.question_uid }, answer: "0" }
        else answer[i] = { question: { uid: d.question_uid }, answer: $(input).val() };
      }

      console.log(answer);

      if (!valueStatus) {
        alert("문항에 대한 응답을 모두 선택해주세요.");
      } else {
        let userId: any = localStorage.getItem('userID');

        const requestBody = {
          family: {
            id: location.state.family_id
          },
          QnAs: answer,
          year: new Date().getFullYear(),
          uid: storeData.assignedUid
        }

        api.post(`customer/api/v2/surveys/assigns/${storeData.assignedUid}`, requestBody, { headers: { 'userId': userId } })
          .then(res => {
            console.log(res);
            if (res.data.success === false) {
              alert(res.data.message);
            } else if (res.data.success === true) {
              alert('저장되었습니다.');
              navigate('/survey/hra/result', { state: storeData.assignedUid });
            }
          })
          .catch(err => {
            // 제출 실패를 알리지 않으면 사용자가 여러 번 눌러 중복 제출이 된다
            notifyApiError(err, '설문을 제출하지 못했습니다.');
          });
      }
    }
  }

  function handleChange(e: any) {
    if (e.target.name == '07911C4976B84307AAFFFCC18BA0C3DD') { // 직계가족 핸들러
      if (e.target.value == '1') {
        $("#direct-family").show();
        $('#viewNumber').addClass('number');
        storeData.setAge('');
      } else {
        $("#direct-family").hide();
        $('#viewNumber').removeClass('number');

        storeData.setSelected('-1');
        storeData.setAge(0);
        $("input[name='EC801C6DC8A04E3F8BD195DE93741FAD'][value='0']").prop("checked", true); //발병
      }
      genRowspan('number');
    }

    if (!$(e).is(":checked")) {
      $(e.target).closest('td').removeClass('focusing');
      $(e.target).closest('td').siblings().removeClass('focusing');
    }

  }

  function handleChangeValue(e: any) {
    console.log(e.target.name);
    if (e.target.name == '7C1D5C7D5A1B4FE68F7EAD11530697E8') { // select
      storeData.setSelected(e.target.value);
    } else if (e.target.name == '45E6758579E94F00B80A00FE9739F126') { // 나이
      storeData.setAge(e.target.value);
    } else if (e.target.name == 'EC801C6DC8A04E3F8BD195DE93741FAD') { // 발병

    }

    $(e.target).closest('td').removeClass('focusing');
    $(e.target).closest('td').siblings().removeClass('focusing');
  }

  return (
    <Container sx={{ p: { xs: 0, md: 0 }, bgcolor: '#F6F6F6', pb: '60px !important', minHeight: '100vh', minWidth: 320 }}>
      <Box sx={{ bgcolor: '#FFEADF', borderRadius: '0 0 40px 40px', display: 'flex', p: 0, minWidth: 320 }} >
        {/* logo */}
        <Box position={'fixed'} width={'100%'} bgcolor={'#ffeadf'} zIndex={999} maxWidth={'1200px'} >
          <Stack direction={'row'} >
            <Box>
              <ButtonBase sx={{ width: 180, height: 50, ml: 1 }}>
                <Img alt="Dual" src="/dual.png" />
              </ButtonBase>
            </Box>
          </Stack>
        </Box>
        <Grid container spacing={2} direction='row' sx={{ mt: 6, }}>
          <Grid container item xs sx={{ mx: 2, my: 5 }} direction='column' justifyContent='center' alignContent={'center'}>
            <Typography className='topText' sx={{ fontSize: '1.5rem', color: '#FF7863', fontWeight: 900, textAlign: 'center'}}>
            뇌심혈관질환 발병위험도평가
            </Typography>
            <Typography sx={{ fontSize: '1.1rem', color: '#EF8322', fontWeight: 500,  textAlign: 'center', mt: 2}} gutterBottom>
            뇌심혈관질환 발병위험도평가를 위한 문진표 작성
            </Typography>
          </Grid>
          
        </Grid>
      </Box>

      <TableContainer sx={{ p: 2, boxSizing:"border-box", mt: 5}}>
        <Paper sx={{ borderRadius: 5}} >
          <Table size="small" className="Cl_table hm_table  " sx={{width: '100%', ml: 'auto', mr: 'auto', bgcolor :'#fff',borderRadius: 5, overflow: 'hidden'}}>
            <TableHead sx={{textAlign: 'center', '& th' : {borderBottom: '1px solid #c5c5c5', borderRight: '1px solid #c5c5c5', bgcolor: "#e7e7e7", p: 1.5}, '& th:last-child' : {borderRight: '0px solid #e0e0e0'}}}>
              <TableRow>
                <TableCell width={10}>No</TableCell>
                <TableCell>내용</TableCell>
                <TableCell width={40}>그렇다</TableCell>
                <TableCell width={40}>아니다</TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{'& #stress-4 td:first-child':{borderBottom: '0px solid #ccc'}, '& .focusing': {bgcolor: 'rgba(255, 152, 139, 0.05) !important'}, '& td' : {padding: '10px !important'} }}>
              {
                storeData.questionsList && storeData.questionsList.map((item: any, idx: number) => {
                  const viewNumber = sex !== "F" ? item.number - 1 : item.number;
                  const nextNum = idx + 1 < storeData.questionsList.length ? storeData.questionsList[idx + 1].number : item.number + 1;
                  const idNumber = (`${viewNumber}`).concat(item.sub_number !== null ? `-${item.sub_number}` : '');

                  if (item.title.indexOf("(*") < 0) { // title에 (* 이 없으면
                    if (item.number === 5 && item.sub_number === 1) { // 5번 문항에 1번째 문항 (sub_number_id 을 넣어주려고)
                      return (
                        <>
                          <TableRow className="category" id={`stress-${viewNumber}`}>
                            <TableCell className="number" sx={{ textAlign: 'center', borderRight: '1px solid rgba(224, 224, 224, 1)'}}>{viewNumber}</TableCell>
                            <TableCell colSpan={3} style={{ fontWeight: 'bold'}}>{item.sub_number_id}</TableCell>
                          </TableRow>
                          <TableRow className="category" id={`stress-${idNumber}`} style={{ display: sex !== "F" && item.number === 1 ? 'none' : '' }}>
                            <TableCell className="number" sx={{ textAlign: 'center', borderRight: '1px solid rgba(224, 224, 224, 1)'}}>{viewNumber}</TableCell>
                            <TableCell>{item.title}</TableCell>
                            <TableCell sx={{ textAlign: 'center'}}>
                              <input name={item.question_uid} type={item.type} value={item.option['그렇다']} onChange={handleChange} />
                            </TableCell>
                            <TableCell sx={{ textAlign: 'center'}}>
                              <input name={item.question_uid} type={item.type} value={item.option['아니다']} onChange={handleChange} />
                            </TableCell>
                          </TableRow>
                        </>
                      );
                    }
                    return ( // 나머지 항목 출력
                      <TableRow className="category" id={`stress-${idNumber}`} key={`stress-${idx}`} style={{ display: sex !== "F" && item.number === 1 ? 'none' : '' }}>
                        <TableCell className="number" sx={{ textAlign: 'center',  borderRight: '1px solid rgba(224, 224, 224, 1)'}}>{viewNumber}</TableCell>
                        <TableCell>{item.title}</TableCell>
                        <TableCell sx={{ textAlign: 'center'}}>
                          <input name={item.question_uid} type={item.type} value={item.option['그렇다']} onChange={handleChange} />
                        </TableCell>
                        <TableCell sx={{ textAlign: 'center'}}>
                          <input name={item.question_uid} type={item.type} value={item.option['아니다']} onChange={handleChange} />
                        </TableCell>
                      </TableRow>
                    );
                  } else { // title에 (* 이 있으면
                    if (item.number === nextNum && item.sub_number !== null && item.sub_number == 1) {
                      return (
                        <TableRow className="category" key={`direct-family-${idx}`} id='direct-family' style={{ display: 'none' }}>
                          <TableCell id='viewNumber' sx={{ textAlign: 'center',  borderRight: '1px solid rgba(224, 224, 224, 1)'}}>{viewNumber}</TableCell>
                          <TableCell colSpan={3} sx={{pt: 2}}>
                              <Typography component='span'>{storeData.splitableTitleList[0].title || ''}</Typography>
                              {
                                item.type === 'select'
                                  ? <Select name={storeData.splitableTitleList[1].uid} size="small" value={storeData.selected} onChange={handleChangeValue} sx={{width: 110, fontSize: 14}}>
                                    {
                                      item.entries.map((item: any, idx: any) => {
                                        return (
                                          <MenuItem key={idx} value={item[1]} sx={{fontSize: 14}}>{item[0]}</MenuItem>
                                        )
                                      })
                                    }
                                  </Select>
                                  : ''
                              }
                              <Typography component='span' sx={{ padding: '0 .5rem', fontSize:14 }}>{storeData.splitableTitleList[1].title || ''}</Typography>
                              <input placeholder="0" name={storeData.splitableTitleList[2].uid} type={storeData.splitableTitleList[2].type} style={{ width: '3rem', textAlign: "center", border: '1px solid #c5c5c5', borderRadius: 3, marginRight: 1, height: '32px' , fontSize: 14}} value={storeData.age} onChange={handleChangeValue} />
                              <Typography component='span' sx={{ fontSize: 14, mr: 1 }}>{storeData.splitableTitleList[2].title}</Typography>
                              <Box sx={{display:'flex', alignItems:'center' , textAlign:'center', mt: 1.5}}>
                                {
                                  storeData.splitableTitleList[3] && Object.keys(storeData.splitableTitleList[3].option).map((key: any, idx: any) => {
                                    if (key === 'hidden') {
                                      return (
                                        <input key={idx} name={storeData.splitableTitleList[3].uid} type={storeData.splitableTitleList[3].type} value={storeData.splitableTitleList[3].option[key]} style={{ visibility: 'hidden' }} />
                                      )
                                    } else {
                                      return (
                                        <Box key={idx} sx={{display:'flex', flexDirection:'column', alignItems:'center', mr: 2}}>
                                          <input name={storeData.splitableTitleList[3].uid} type={storeData.splitableTitleList[3].type} value={storeData.splitableTitleList[3].option[key]} onChange={handleChangeValue} />
                                          <Typography component='span' sx={{ fontSize:14}} >{key}</Typography>
                                        </Box>
                                      )
                                    }
                                  })
                                }
                                <Typography component='p' sx={{ fontSize: 14}}>{storeData.splitableTitleList[3].title}</Typography>
                              </Box>
                            <Typography component='p' sx={{ fontSize: '90%', mt: 2, mb: 1, color: '#555' }}>{storeData.splitableTitleList[4].title}</Typography>

                          </TableCell>
                        </TableRow>
                      );
                    } else {
                      return null;
                    }
                  }
                })
              }

              {/* {
                storeData.questionsList.map((item: any, idx: any) => {
                  const viewNumber = sex !== "F" ? item.number - 1 : item.number;
                  const idNumber = `${viewNumber}${item.sub_number !== null ? `-${item.sub_number}` : ''}`;
                  const nextNum = idx + 1 < storeData.questionsList.length ? storeData.questionsList[idx + 1].number : item.number + 1;

                  if (item.title.indexOf("(*") < 0) { // title에 (* 이 없으면
                    if (item.number === 5 && item.sub_number === 1) { // 5번 문항에 1번째 문항 (sub_number_id 을 넣어주려고)
                      return (
                        <TableRow key={`stress-${item.number}`}>
                          <TableCell className="number">{viewNumber}</TableCell>
                          <TableCell colSpan={3} style={{ fontWeight: 'bold' }}>{item.sub_number_id}</TableCell>
                        </TableRow>
                      );
                    }
                    return ( // 나머지 항목 출력
                      <TableRow key={`stress-${idNumber}`} style={{ display: sex !== "F" && item.number === 1 ? 'none' : '' }}>
                        <TableCell className="number">{viewNumber}</TableCell>
                        <TableCell>{item.title}</TableCell>
                        {
                          item.type !== 'select'
                            ? <>
                              <TableCell>
                                <input name={item.question_uid} type={item.type} value={item.option['그렇다']} onChange={handleChange} />
                              </TableCell>
                              <TableCell>
                                <input name={item.question_uid} type={item.type} value={item.option['아니다']} onChange={handleChange} />
                              </TableCell>
                            </>
                            : <>
                              ''
                            </>
                        }

                      </TableRow>
                    );
                  } else { // title에 (* 이 있으면
                    if (item.number === nextNum && item.sub_number !== null) {
                      return (
                        <TableRow key={`direct-family-${idNumber}`} id='direct-family' style={{ display: 'none' }}>
                          <TableCell id='viewNumber'>{viewNumber}</TableCell>
                          <TableCell colSpan={3}>
                            <Typography component='span'>{item.splitableTitle[1]}</Typography>
                            <input name={item.question_uid} type={item.type} sx={{ width: '5rem' }} />
                            {
                              !!item.splitableTitle[1] ? <Typography component='span' sx={{ padding: '0 .5rem' }}>{item.splitableTitle[1]}</Typography> : ''
                            }
                            {
                              !!item.splitableTitle[2] ? <Typography component='div' sx={{ paddingTop: '1rem', fontSize: '90%' }}>{item.splitableTitle[2]}</Typography> : ''
                            }
                          </TableCell>
                        </TableRow>
                      );
                    } else {
                      return null;
                    }
                  }

                })
              } */}
            </TableBody>
          </Table>
        </Paper>
      </TableContainer>

      <Box sx={{ textAlign: 'center', p: 2, mb:5 }}>
        <Alert severity="error">제출 후에는 수정할 수 없습니다.</Alert>
        <Button variant="contained" onClick={handleSubmitSurvey} sx={{ mt: 3, background: '#EF8322', p:1, borderRadius: 20, width: '100%', '&:hover': { background: '#EF8322' } }}>제출하기</Button>
      </Box>

      <Bottom />
    </Container>
  )
}

const submit_button = {
  width: '25%',
  bgcolor: '#0d6703',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #0d6703',
  ':hover': {
    backgroundColor: '#074300',
    borderColor: '#074300',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
  mt: 3, mb: 5
}

export default HraAnswer;